var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { ButtonKVBase, DefaultModal, AlertMessage } from '@/presentation/components';
import Styles from './paybill-modal-styles.scss';
import AccountSelect from './components/select';
import { payBillModalState } from './components/atoms';
import { useRecoilState, useResetRecoilState } from 'recoil';
import AmountInput from './components/input';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import useCustomToast from '@/presentation/hooks/use-custom-toast';
import { parseNumberMoney } from '@/presentation/utils/number-utils';
import { mapAccountLabel } from '@/presentation/pages/transfer-funds-modal/transfer-funds-modal';
const PayBillModal = ({ openModal, setOpenModal, validationPayBill, manageVirtualTransactions, accountFromParam, accountToParam }) => {
    const resetState = useResetRecoilState(payBillModalState);
    const [state, setState] = useRecoilState(payBillModalState);
    const { getAccounts, refeshAccounts, creditCardAccount } = useStudentAccounts(false);
    const accounts = getAccounts();
    // const [showPopup, setShowPopup] = useState(false);
    const { showCustomError, showCustomSuccess } = useCustomToast({
        containerId: 'main-dashboard-container'
    });
    const makeTransfer = () => __awaiter(void 0, void 0, void 0, function* () {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        const response = yield manageVirtualTransactions.makeTransaction({
            idAccountFrom: parseInt(state.accountFrom.value),
            idAccountTo: creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.id,
            amount: state.amount
        });
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: false })));
        if (response) {
            if ((response === null || response === void 0 ? void 0 : response.message) === 'INSUFFICIENT_FUNDS') {
                showCustomError('Insufficient Funds', 'You do not have enough funds to make this transfer.');
            }
            else if ((response === null || response === void 0 ? void 0 : response.message) === 'BALANCE_IS_LESS') {
                showCustomError('Error', 'Credit card balance is less than the amount to be paid.');
            }
            else {
                if (response === null || response === void 0 ? void 0 : response.status) {
                    refeshAccounts();
                    showCustomSuccess('Success', 'Transfer completed successfully.');
                    resetState();
                    setOpenModal(false);
                }
                else {
                    showCustomError('Error', response === null || response === void 0 ? void 0 : response.message);
                }
            }
        }
        else {
            showCustomError('Error', 'An error occurred while making the transfer. Please try again later.');
        }
    });
    useEffect(() => {
        if (accountToParam) {
            setState(prev => (Object.assign(Object.assign({}, prev), { accountTo: { value: 'Credit Card', label: 'Credit Card' } })));
        }
    }, [accountToParam]);
    const fromAccountsOptions = accounts
        .filter(i => { var _a, _b; return ((_a = i.accountType) === null || _a === void 0 ? void 0 : _a.description) !== 'Credit Card' && ((_b = i.accountType) === null || _b === void 0 ? void 0 : _b.description) !== 'Pocket'; })
        .map(account => ({
        value: account.id.toString(),
        label: mapAccountLabel(account)
    }));
    const minPayment = parseFloat(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance) * 0.03;
    const invalidForm = (state === null || state === void 0 ? void 0 : state.amount) < minPayment || (state === null || state === void 0 ? void 0 : state.accountFrom) === null || (state === null || state === void 0 ? void 0 : state.accountTo) === null;
    return (React.createElement(DefaultModal, { height: "60.24", hUnit: "vh", width: "53.89", wUnit: "vw", open: openModal, onClose: () => setOpenModal(false), overlayCustomStyles: { zIndex: 9999 }, contentCustomStyles: { top: '35%' }, showClose: true },
        React.createElement("div", { className: Styles.mainWrap },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: Styles.t1 }, "Pay Bill"),
                React.createElement("div", { className: Styles.wrapAccounts },
                    React.createElement("div", null,
                        React.createElement(AccountSelect, { name: 'accountFrom', label: 'FROM ACCOUNT', placeholder: 'Select account...', required: true, options: fromAccountsOptions })),
                    React.createElement("div", null,
                        React.createElement(AccountSelect, { name: 'accountTo', label: 'TO ACCOUNT', placeholder: 'Select account...', required: true, options: [
                                {
                                    value: 'Credit Card',
                                    label: 'Credit Card'
                                }
                            ], isDisabled: true }))),
                React.createElement("div", { className: Styles.paymentWrap, style: { padding: '1rem 0rem', width: '75%' } },
                    React.createElement(AmountInput, { name: "amount", type: "number", placeholder: "0.00", label: "AMOUNT", required: true }),
                    React.createElement("div", { className: Styles.paymentSummary },
                        React.createElement("div", { className: Styles.group },
                            React.createElement("div", { className: Styles.label }, "Minimum Payment:"),
                            React.createElement("div", { className: Styles.minPayment }, `${parseNumberMoney(minPayment)} KV`)),
                        React.createElement("div", { className: Styles.group },
                            React.createElement("div", { className: Styles.label }, "Full Balance: "),
                            React.createElement("div", { className: Styles.fullBalance }, `${parseNumberMoney(creditCardAccount === null || creditCardAccount === void 0 ? void 0 : creditCardAccount.balance)} KV`)))),
                React.createElement("div", { className: Styles.alertMessageWrap },
                    React.createElement(AlertMessage, { background: "#FFF8DD", fontSize: "14px", message: 'Any payment made must pay the minimum payment or higher. We recommend paying your balance in full to avoid interest charges.' })),
                React.createElement("div", { style: { padding: '1rem 0rem' } },
                    React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", disabled: invalidForm, onClick: makeTransfer, loading: state.isLoading }, "Confirm"))))));
};
export default PayBillModal;
